/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_With_EmailInputs */

const en_signin_with_email = /** @type {(inputs: Signin_With_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or with your email`)
};

/** @type {(inputs: Signin_With_EmailInputs) => LocalizedString} */
const ar_signin_with_email = en_signin_with_email;

/** @type {(inputs: Signin_With_EmailInputs) => LocalizedString} */
const he_signin_with_email = en_signin_with_email;

/** @type {(inputs: Signin_With_EmailInputs) => LocalizedString} */
const ur_signin_with_email = en_signin_with_email;

/** @type {(inputs: Signin_With_EmailInputs) => LocalizedString} */
const es_signin_with_email = en_signin_with_email;

/** @type {(inputs: Signin_With_EmailInputs) => LocalizedString} */
const fr_signin_with_email = en_signin_with_email;

/** @type {(inputs: Signin_With_EmailInputs) => LocalizedString} */
const de_signin_with_email = en_signin_with_email;

/** @type {(inputs: Signin_With_EmailInputs) => LocalizedString} */
const pt_signin_with_email = en_signin_with_email;

/** @type {(inputs: Signin_With_EmailInputs) => LocalizedString} */
const hi_signin_with_email = en_signin_with_email;

/** @type {(inputs: Signin_With_EmailInputs) => LocalizedString} */
const bn_signin_with_email = en_signin_with_email;

/**
* | output |
* | --- |
* | "or with your email" |
*
* @param {Signin_With_EmailInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_with_email = /** @type {((inputs?: Signin_With_EmailInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_With_EmailInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_with_email(inputs)
	if (locale === "he") return he_signin_with_email(inputs)
	if (locale === "ur") return ur_signin_with_email(inputs)
	if (locale === "es") return es_signin_with_email(inputs)
	if (locale === "fr") return fr_signin_with_email(inputs)
	if (locale === "de") return de_signin_with_email(inputs)
	if (locale === "pt") return pt_signin_with_email(inputs)
	if (locale === "hi") return hi_signin_with_email(inputs)
	if (locale === "bn") return bn_signin_with_email(inputs)
	return /** @type {LocalizedString} */ ("or with your email")
});